import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {takeLatest, call} from 'redux-saga/effects';

import {getSignedURLSaga} from 'api/allocations';

const namespace = 'flows/docs/signed';

// Actions
export const LOAD = defineAction('LOAD', namespace);
export const load = createAction(LOAD.ACTION);

// LoggedIn Saga
export function* retrieveSignedSaga({payload}) {
  // Call api
  const {id} = payload;
  // Get pre signed url
  const url = yield call(getSignedURLSaga, {payload: {id}});
  // Redirect
  window.location = url
}

export function* sagas() {
  yield takeLatest(LOAD.ACTION, retrieveSignedSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/docs/signed/index.js